import { CustomDialog } from "../../../components/customDialog/CustomDialog";

export function ConfirmCancelDialog({ open, loading, handleCreateOrUpdateOrdenPedido, handleCloseDialog }) {
  const onAccept = () => {
    handleCreateOrUpdateOrdenPedido();
  };

  return (
    <CustomDialog
      title="Cancelación de envío"
      open={open}
      fullWidth
      maxWidth="sm"
      onCancel={handleCloseDialog}
      cancelText="Cerrar"
      acceptText="Aceptar"
      onAccept={onAccept}
      acceptLoading={loading}
    >
      <div>¿Está seguro de <strong>Cancelar</strong> el envío?</div>
      
    </CustomDialog>);

}